import React, { Suspense, useContext } from 'react'
import { UseNotFoundContext } from '../../../components/not-found/hooks/use-not-found-context'

const LazyNavigationFooter = React.lazy(() => import('./navigation-footer-wrapper'))

const NavigationFooterLoader = props => (
  <Suspense fallback={null}>
    <LazyNavigationFooter {...props} />
  </Suspense>
)
const AsyncNavigationFooter = props => {
  const [{ isNotFoundRendered }] = useContext(UseNotFoundContext)
  if (isNotFoundRendered) {
    return null
  }
  return <NavigationFooterLoader {...props} />
}

export default AsyncNavigationFooter
